import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Search as BaseSearchIcon } from '@mui/icons-material'
import { Spinner as BaseSpinner } from '@chilecompra/react-kit/components'

export const Form = styled('form')`
  width: 100%;
`

export const Grid = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const GridUTP = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
    width: ${props => props.width};
  }
`

export const Search = styled(({ loading, ...props }) => <button {...props} />)`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.primary};
  border: 0;
  border-radius: 0;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 100%;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  outline: 0;
  pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  user-select: ${props => (props.disabled ? 'none' : 'initial')};
  width: 40px;

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[35]};
  }
`

export const SearchIcon = styled(BaseSearchIcon)`
  color: ${props => props.theme.palette.brand.white};
  height: 24px;
  width: 24px;
`

export const SearchLoadingIcon = styled(props => <BaseSpinner {...props} color="white" size="18px" />)``

export const SpinnerRoot = styled('div')`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const CustomCard = styled('div')`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 8px;
  margin: 0 0 25px;
  padding: 20px 20px 10px;
  background-color: ${props => props.theme.palette.blank};
`

export const ToastFontContainer = styled('div')`
  margin-bottom: 10px;

  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`

export const Divider = styled('div')`
  margin-bottom: 5px;
`

export const Strong = styled('b')`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`
